import { render, staticRenderFns } from "./MartPartnerProductDetail.vue?vue&type=template&id=33f3f8e6&scoped=true"
import script from "./MartPartnerProductDetail.vue?vue&type=script&lang=js"
export * from "./MartPartnerProductDetail.vue?vue&type=script&lang=js"
import style0 from "./MartPartnerProductDetail.vue?vue&type=style&index=0&id=33f3f8e6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f3f8e6",
  null
  
)

export default component.exports